// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"208":"f2828254","362":"51c39c61","640":"883238a7","781":"1352a8ef","820":"31d6cfe0","888":"e7a9fbba","961":"679f0d94"}[chunkId] + ".chunk.css";
};